const omitUndefined = (obj = {}) =>
  Object.entries(obj).reduce(
    (acc, [key, value]) => (value ? { ...acc, [key]: value } : acc),
    {}
  );

export default omitUndefined;
